// Theme switching: sets <html data-theme> and persists to localStorage.
// index.html applies the saved value before first paint.
import { createSignal } from 'solid-js';

const KEY = 'payroll.theme';
const initial = document.documentElement.getAttribute('data-theme') || 'dark';
const [theme, setThemeSignal] = createSignal(initial);

export { theme };

export function setTheme(t) {
  document.documentElement.setAttribute('data-theme', t);
  try { localStorage.setItem(KEY, t); } catch {}
  setThemeSignal(t);
}

export function toggleTheme() {
  setTheme(theme() === 'dark' ? 'light' : 'dark');
}
